export const TESTIMONIALS = [
  {
    image: "/media/images/avatars/1.png",
    name: "Guy Hawkins",
    occupation: "Dog Trainer",
    review: `Varius sit amet mattis vulputate enim nulla aliquet porttitor lacus luctus accumsan tortor posuere ac ut consequat semper viverra nam libero justo laoreet sit amet cursus sit amet dictum sit amet justo donec enim diam vulputate ut pharetra sit amet aliquam id diam maecenas ultricies mi eget`,
  },
  {
    image: "/media/images/avatars/2.png",
    name: "Devon Lane",
    occupation: "Web Designer",
    review: `Lorem ipsum dolor sit amet, consectetur`,
  },
  {
    image: "/media/images/avatars/3.png",
    name: "Eleanor Pena",
    occupation: "Nursing Assistant",
    review: `Isnteger feugiat scelerisque varius morbi enim nunc faucibus a pellentesque sit amet porttitor eget dolor morbi non arcu risus quis varius quam quisque id diam vel quam elementum pulvinar etiam non quam lacus suspendisse faucibus interdum posuere lorem ipsum dolor sit amet consectetur`,
  },
  {
    image: "/media/images/avatars/5.png",
    name: "Courtney Henry",
    occupation: "Marketing Coordinator",
    review: `Orci nulla pellentesque dignissim enim sit amet venenatis urna cursus eget nunc scelerisque viverra mauris in aliquam sem fringilla ut morbi tincidunt augue interdum velit euismod in pellentesque massa placerat duis ultricies lacus sed turpis tincidunt id aliquet risus feugiat in ante metus dictum at tempor commodo ullamcorper a lacus vestibulum sed arcu non odio euismod lacinia at quis risus sed vulputate odio ut enim blandit volutpat maecenas volutpat blandit aliquam etiam erat velit scelerisque in dictum non consectetur a erat nam at lectus urna duis convallis convallis`,
  },
  {
    image: "/media/images/avatars/4.png",
    name: "Marvin McKinney",
    occupation: "Medical Assistant",
    review: `Jsed augue lacus viverra vitae congue eu consequat ac felis donec et odio pellentesque diam volutpat commodo sed egestas egestas fringilla phasellus faucibus scelerisque eleifend donec pretium`,
  },
  {
    image: "/media/images/avatars/6.png",
    name: "Ralph Edwards",
    occupation: "President of Sales",
    review: `Lectus proin nibh nisl condimentum id venenatis a condimentum vitae sapien pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas sed tempus urna et pharetra pharetra massa massa ultricies mi quis`,
  },
];
